var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.5523 0C13.6162 0.0145896 12.7005 0.276427 11.8977 0.759071C11.0949 1.24171 10.4334 1.92807 9.98 2.74884C9.52662 1.92807 8.86513 1.24171 8.06232 0.759071C7.2595 0.276427 6.3438 0.0145896 5.40768 0C3.91539 0.0649647 2.50941 0.719074 1.49691 1.81942C0.484417 2.91977 -0.0522986 4.37692 0.00402456 5.87251C0.00402456 11.516 9.11209 18.034 9.49949 18.3106L9.98 18.6513L10.4605 18.3106C10.8479 18.0357 19.956 11.516 19.956 5.87251C20.0123 4.37692 19.4756 2.91977 18.4631 1.81942C17.4506 0.719074 16.0446 0.0649647 14.5523 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartWhite);
export default __webpack_public_path__ + "static/media/heart-white.b375fc49768680e157cdd0925d3951de.svg";
export { ForwardRef as ReactComponent };